import { apiPaths } from 'const';

import { AuthServiceApi } from './AuthServiceApi';
import { DnevnikApi } from './DnevnikApi';
import { ExcelServiceApi } from './ExcelServiceApi';
import { MainApi } from './MainApi';
import { MosVuzApi } from './MosVuzApi';

export * from './types';

export const mainApi = new MainApi(`${apiPaths.PORTFOLIO}${apiPaths.BASE_PREFIX}`);
export const referenceApi = new MainApi(`${apiPaths.PORTFOLIO}${apiPaths.BASE_PREFIX}${apiPaths.REFERENCE}`);
export const authServiceApi = new AuthServiceApi(`${apiPaths.PORTFOLIO}${apiPaths.BASE_PREFIX}`);
export const excelServiceApi = new ExcelServiceApi(`${apiPaths.PORTFOLIO}${apiPaths.BASE_PREFIX}`);
export const dnevnikApi = new DnevnikApi();
export const mosVuzApi = new MosVuzApi(`${apiPaths.PORTFOLIO}`);
